import { isRedirectError } from "./redirect";
import { isHTTPAccessFallbackError, getAccessFallbackHTTPStatus } from "./http-access-fallback";

export { isRedirectError } from "./redirect";
export type { RedirectError } from "./redirect";

export { isHTTPAccessFallbackError, getAccessFallbackHTTPStatus } from "./http-access-fallback";
export type { HTTPAccessFallbackError } from "./http-access-fallback";

/**
 * Checks if the error is a navigation error that should be re-thrown
 * This includes redirect errors and HTTP access errors (notFound, forbidden, unauthorized)
 */
export function isNextNavigationError(error: unknown): boolean {
	return isRedirectError(error) || isHTTPAccessFallbackError(error);
}

/**
 * Checks if the error is a notFound error
 * Note: Next.js implements notFound() using HTTP_ERROR_FALLBACK with status 404,
 * not as a separate error type like NEXT_REDIRECT
 */
export function isNotFoundError(error: unknown): boolean {
	return isHTTPAccessFallbackError(error) && getAccessFallbackHTTPStatus(error as any) === 404;
}